import CloudinaryImage from "components/cloudinary-image"
import styled from "styled-components"
import minWidth from "utils/minWidth"

export const Card = styled.div`
  position: relative;
  width: 23rem;
  height: 36rem;
  margin-right: 1.7rem;

  ${minWidth.mobile`
    width: 27rem;
    height: 40.5rem;
    margin-right:0;
  `}

  border-radius: 0.4rem;
  overflow: hidden;
  transition: transform 0.3s ease;

  a {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
  }
`

export const CardImage = styled.figure`
  width: 23rem;
  height: 36rem;
  margin: 0;

  ${minWidth.mobile`
    width: 27rem;
    height: 40.5rem;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const CardOverlay = styled.div`
  min-height: 45%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 1.5rem;
  border-radius: 0.4rem;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  margin: 0 0.6rem 2rem 0.6rem;
  ${minWidth.mobile`
    margin: 0.6rem;

  `}
`
export const ContentWrapper = styled.div`
  flex: 1;
`

export const Name = styled.h3`
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: white;
`
export const Credentials = styled.h3`
  font-size: 1.4rem;
  color: white;
  margin: 0 0 0.8rem 0;
`

export const Role = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  margin-bottom: 1.2rem;
  color: white;
`
export const NameWrapper = styled.div`
  margin-bottom: 1.2rem;
`
export const Image = styled(CloudinaryImage)`
  padding-bottom: 150%;

  img {
    height: auto;
    vertical-align: middle;
    background-color: #f3f3f3;
  }
`

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  background: white;
  border-radius: 0.4rem;
  padding: 0.6rem 1.2rem;
  gap: 0.8rem;
  margin-top: auto;
  svg {
    width: 1.6rem;
    height: 1.6rem;
    color: #222;
  }

  span {
    font-size: 1.2rem;
    font-weight: 500;
    color: #222;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }
`
